<template>
    <v-card class="mt-2" flat>
        <v-row no-gutters>
            <v-col md="12">
                <v-card elevation="0" class="px-4">
                    <!-- <v-row>
                        <v-col md="12" class="mb-1 mt-1">
                            <h4 class="font-weight-light primary--text">
                                Datos
                            </h4>
                        </v-col>
                    </v-row>
                    <v-divider></v-divider> -->
                    <v-row class="mb-n7">
                        <v-col xl="4" lg="4" md="4" cols="12">
                            <v-text-field
                                v-model="Name"
                                label="Nombre"
                                style="padding: 21.1px 0px 17px 0px"
                            ></v-text-field>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" cols="12">
                            <v-select
                                clearable
                                hide-selected
                                chips
                                :items="Object.keys(procedureTypes)"
                                v-model="Type"
                                label="Tipo"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        :color="
                                            isEditableForm
                                                ? 'yellow lighten-3'
                                                : 'yellow darken-2'
                                        "
                                        class="white--text"
                                    >
                                        {{ item }}
                                        <v-icon> mdi-store-outline </v-icon>
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                        <v-col xl="4" lg="4" md="4" cols="12">
                            <v-select
                                clearable
                                chips
                                :items="opciones.tarifas.operator"
                                item-text="human"
                                item-value="encoded"
                                v-model="Operator"
                                :label="Operator ? Operator : 'Operador'"
                            >
                                <template #selection="{ item }">
                                    <v-chip
                                        :color="
                                            isEditableForm
                                                ? 'primary lighten-3'
                                                : 'primary'
                                        "
                                        class="white--text"
                                    >
                                        <v-icon> mdi-signal-variant </v-icon>
                                        {{ item.human }}
                                    </v-chip>
                                </template>
                            </v-select>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <!-- <v-col v-if="autoUpfront" md="5" class="pl-1">
                                    <v-card class="px-4" text>
                                        <v-row>
                                            <v-col md="6" class="mb-1 mt-1">
                                                <h4
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Familia Objetivo
                                                </h4>
                                            </v-col>
                                            <v-col md="6" class="mb-1 mt-1">
                                                <h4
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Upfront
                                                </h4>
                                            </v-col>
                                        </v-row>
                                        <v-divider></v-divider>
                                        <v-row class="mb-n7 mt-n2">
                                            <v-col md="7">
                                                <v-select
                                                    clearable
                                                    hide-selected
                                                    chips
                                                    multiple
                                                    deletable-chips
                                                    :items="tipoObjetivo"
                                                    item-text="nombre"
                                                    return-object
                                                    v-model="FamiliaObjetivo"
                                                    label="Tipo"
                                                >
                                                    <template
                                                        #selection="{ item }"
                                                    >
                                                        <v-chip
                                                            :color="
                                                                isEditableForm
                                                                    ? 'yellow lighten-3'
                                                                    : 'yellow darken-2'
                                                            "
                                                            class="white--text"
                                                        >
                                                            {{ item.nombre }}
                                                            <v-icon>
                                                                mdi-format-list-bulleted-type
                                                            </v-icon>
                                                        </v-chip>
                                                    </template>
                                                </v-select>
                                            </v-col>
                                            <v-col md="3">
                                                <v-text-field
                                                    v-model="Upfront"
                                                    label="Cantidad"
                                                    required
                                                    style="
                                                        padding: 21.1px 0px 12px
                                                            0px;
                                                    "
                                                ></v-text-field>
                                            </v-col>
                                            <v-col
                                                md="2"
                                                style="
                                                    padding: 21px 10px 0px 10px;
                                                "
                                            >
                                                <v-select
                                                    hide-selected
                                                    :items="['€']"
                                                    label="Unidad"
                                                    value="€"
                                                    disabled
                                                >
                                                </v-select>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </v-col> -->
        </v-row>
        <!-- <v-card-actions
                                class="justify-end mb-n4 mr-n6"
                            >
                                <v-btn text color="red" @click="closeForm">
                                    Cerrar
                                </v-btn>
                                <v-btn
                                    color="primary"
                                    @click="submitProcedure"
                                    v-if="!isEditableForm"
                                >
                                    Guardar
                                </v-btn>
                            </v-card-actions> -->
    </v-card>
    <!-- </v-dialog>
                </v-card>
            </v-col>
        </v-row>
    </v-form> -->
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'procedureManagementForm',
    data: () => ({
        procedureTypes: {
            CAMBIO_DOMICILIO: 'Cambio Domicilio',
            PRIMERA_RECARGA: 'Primera Recarga',
            ENTREGA_PDV: 'Entrega PDV',
            SEGURO_FAMILIA: 'Seguro Familia',
            RV_DEVOLVER: 'RV Devolver',
            RV_APLAZAR: 'RV Aplazar',
            RENUEVO: 'Renuevo',
            SIN_DEFINIR: 'Sin definir',
        },
        autoUpfront: true,
    }),
    methods: {
        clearFields() {
            this.$store.state.ManagementBase.procedureManagement.Name = '';
            this.$store.state.ManagementBase.procedureManagement.Operator = '';
            // this.$store.state.ManagementBase.procedureManagement.Upfront = 0;
            // this.$store.state.ManagementBase.procedureManagement.TipoObjetivo =
            //     '';
            this.$store.state.ManagementBase.procedureManagement.Type = '';
            this.$store.state.ManagementBase.procedureManagement.IsActive = false;
        },
        closeForm() {
            this.$store.commit(
                'ManagementBase/procedureManagement/isOpenDialog',
                false
            );
            this.clearFields();
        },
        submitProcedure() {
            if (
                this.$store.state.ManagementBase.procedureManagement.formType ==
                'add'
            )
                this.$store.dispatch(
                    'ManagementBase/procedureManagement/addProcedure'
                );
            else
                this.$store.dispatch(
                    'ManagementBase/procedureManagement/editProcedure'
                );

            this.closeForm();
        },
    },
    computed: {
        isOpenDialog: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .isOpenDialog;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/isOpenDialog',
                    val
                );
                this.clearFields();
            },
        },
        Name: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .Name;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/Name',
                    val
                );
            },
        },
        Operator: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .Operator;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/Operator',
                    val
                );
            },
        },
        Type: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .Type;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/Type',
                    val
                );
            },
        },
        Upfront: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .Upfront;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/Upfront',
                    val
                );
            },
        },
        FamiliaObjetivo: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .FamiliaObjetivo;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/FamiliaObjetivo',
                    val
                );
            },
        },
        IsActive: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .IsActive;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/IsActive',
                    val
                );
            },
        },
        formType: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .formType;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/formType',
                    val
                );
            },
        },
        isEditableForm: {
            get() {
                return this.$store.state.ManagementBase.procedureManagement
                    .isEditableForm;
            },
            set(val) {
                this.$store.commit(
                    'ManagementBase/procedureManagement/isEditableForm',
                    val
                );
            },
        },
        opciones() {
            return JSON.parse(localStorage.getItem('opciones'));
        },
        ...mapState('ManagementBase', {
            tipoObjetivo: (state) => state.tipoObjetivo,
        }),
    },
};
</script>
